import {
  CoatingFormFields,
  CoatingJSONFromFormFields,
  CoatingRegionFeatureTableOptions,
  ConeCircumferentialWeldFeatureTableOptions,
  ConeCircumferentialWeldFormFields,
  ConeCircumferentialWeldJSONFromFormFields,
  ConeCourseFeatureTableOptions,
  ConeCourseFormFields,
  ConeCourseJSONFromFormFields,
  ConePlateFeatureTableOptions,
  ConeRadialWeldFeatureTableOptions,
  ConeRadialWeldFormFields,
  ConeRadialWeldJSONFromFormFields,
  ConicalPlateFormFields,
  ConicalPlateJSONFromFormFields,
  FeatureTableOptions,
  FixedSensorFeatureTableOptions,
  FixedSensorFormFields,
  FixedSensorJSONFromFormFields,
  FormField,
  GeckoFeatureModelType,
  GeckoFeaturesJSON,
  getFormFieldByDataKey,
  HorizontalWeldFeatureTableOptions,
  HorizontalWeldJSONFromFormFields,
  HorizontalWeldModelFormFields,
  LeakDetectionValveFeatureTableOptions,
  LeakDetectionValveFormFields,
  LeakDetectionValveJSONFromFormFields,
  LegacyBoilerRepairRegionFeatureTableOptions,
  LegacyBoilerRepairRegionFormFields,
  LegacyBoilerRepairRegionJSONFromFormFields,
  LegacyBoilerWallFeatureTableOptions,
  LegacyBoilerWallFormFields,
  LegacyBoilerWallJSONFromFormFields,
  LinerFormFields,
  LinerJSONFromFormFields,
  LinerRegionFeatureTableOptions,
  ManwayFeatureTableOptions,
  ManwayFormFields,
  ManwayJSONFromFormFields,
  NewGeckoCoatingJSON,
  NewGeckoConeCircumferentialWeldJSON,
  NewGeckoConeCourseJSON,
  NewGeckoConeRadialWeldJSON,
  NewGeckoConicalPlateJSON,
  NewGeckoCourseJSON,
  NewGeckoFixedSensorJSON,
  NewGeckoHorizontalWeldJSON,
  NewGeckoLeakDetectionValveJSON,
  NewGeckoLegacyBoilerRepairRegionJSON,
  NewGeckoLegacyBoilerWallJSON,
  NewGeckoLinerJSON,
  NewGeckoManwayJSON,
  NewGeckoNozzleJSON,
  NewGeckoPipeCircumferentialWeldJSON,
  NewGeckoPipeIntegralSupportJSON,
  NewGeckoPipeNonIntegralSupportJSON,
  NewGeckoPipeSeamWeldJSON,
  NewGeckoPipeWrapJSON,
  NewGeckoPlateJSON,
  NewGeckoPolygonalPlateJSON,
  NewGeckoShipDeckBittJSON,
  NewGeckoShipDeckChockJSON,
  NewGeckoShipDeckHatchJSON,
  NewGeckoSphericalPlateJSON,
  NewGeckoVerticalWeldJSON,
  NozzleFeatureTableOptions,
  NozzleFormFields,
  NozzleJSONFromFormFields,
  PipeCircumferentialWeldFeatureTableOptions,
  PipeCircumferentialWeldFormFields,
  PipeCircumferentialWeldJSONFromFormFields,
  PipeIntegralSupportFeatureTableOptions,
  PipeIntegralSupportFormFields,
  PipeIntegralSupportJSONFromFormFields,
  PipeNonIntegralSupportFeatureTableOptions,
  PipeNonIntegralSupportFormFields,
  PipeNonIntegralSupportJSONFromFormFields,
  PipeSeamWeldFeatureTableOptions,
  PipeSeamWeldFormFields,
  PipeSeamWeldJSONFromFormFields,
  PipeWrapFeatureTableOptions,
  PipeWrapFormFields,
  PipeWrapJSONFromFormFields,
  PlateFeatureTableOptions,
  PlateFormFields,
  PlateJSONFromFormFields,
  PolygonalPlateFeatureTableOptions,
  PolygonalPlateFormFields,
  PolygonalPlateJSONFromFormFields,
  ShellCourseFeatureTableOptions,
  ShellCourseFormFields,
  ShellCourseJSONFromFormFields,
  ShipDeckBittFeatureTableOptions,
  ShipDeckBittFormFields,
  ShipDeckBittJSONFromForm,
  ShipDeckChockFeatureTableOptions,
  ShipDeckChockFormFields,
  ShipDeckChockJSONFromFormFields,
  ShipDeckHatchFeatureTableOptions,
  ShipDeckHatchFormFields,
  ShipDeckHatchJSONFromFormFields,
  SortTableByField,
  SphericalPlateFeatureTableOptions,
  SphericalPlateFormFields,
  SphericalPlateJSONFromFormFields,
  VerticalWeldFeatureTableOptions,
  VerticalWeldJSONFromFormFields,
  VerticalWeldModelFormFields,
} from 'types'

export const getFormFieldsForFeatureType = (
  feature: GeckoFeaturesJSON
): FormField[] => {
  const featureType = feature.type
  switch (featureType) {
    case GeckoFeatureModelType.VerticalWeld:
      return VerticalWeldModelFormFields(feature)
    case GeckoFeatureModelType.HorizontalWeld:
      return HorizontalWeldModelFormFields(feature)
    case GeckoFeatureModelType.Plate:
      return PlateFormFields(feature)
    case GeckoFeatureModelType.Nozzle:
      return NozzleFormFields(feature)
    case GeckoFeatureModelType.Manway:
      return ManwayFormFields(feature)
    case GeckoFeatureModelType.FixedSensor:
      return FixedSensorFormFields(feature)
    case GeckoFeatureModelType.PolygonalPlate:
      return PolygonalPlateFormFields(feature)
    case GeckoFeatureModelType.LegacyBoilerRepairRegion:
      return LegacyBoilerRepairRegionFormFields(feature)
    case GeckoFeatureModelType.LegacyBoilerWall:
      return LegacyBoilerWallFormFields(feature)
    case GeckoFeatureModelType.ConeCourse:
      return ConeCourseFormFields(feature)
    case GeckoFeatureModelType.Course:
      return ShellCourseFormFields(feature)
    case GeckoFeatureModelType.ConeCircumferentialWeld:
      return ConeCircumferentialWeldFormFields(feature)
    case GeckoFeatureModelType.ConeRadialWeld:
      return ConeRadialWeldFormFields(feature)
    case GeckoFeatureModelType.ShipDeckBitt:
      return ShipDeckBittFormFields(feature)
    case GeckoFeatureModelType.ShipDeckChock:
      return ShipDeckChockFormFields(feature)
    case GeckoFeatureModelType.ShipDeckHatch:
      return ShipDeckHatchFormFields(feature)
    case GeckoFeatureModelType.PipeSeamWeld:
      return PipeSeamWeldFormFields(feature)
    case GeckoFeatureModelType.PipeCircumferentialWeld:
      return PipeCircumferentialWeldFormFields(feature)
    case GeckoFeatureModelType.PipeNonIntegralSupport:
      return PipeNonIntegralSupportFormFields(feature)
    case GeckoFeatureModelType.PipeIntegralSupport:
      return PipeIntegralSupportFormFields(feature)
    case GeckoFeatureModelType.PipeWrap:
      return PipeWrapFormFields(feature)
    case GeckoFeatureModelType.ConePlate:
      return ConicalPlateFormFields(feature)
    case GeckoFeatureModelType.CoatingRegion:
      return CoatingFormFields(feature)
    case GeckoFeatureModelType.SphericalPlate:
      return SphericalPlateFormFields(feature)
    case GeckoFeatureModelType.LeakDetectionValve:
      return LeakDetectionValveFormFields(feature)
    case GeckoFeatureModelType.LinerRegion:
      return LinerFormFields(feature)
  }
}

export const getJSONFromFeatureFormFields = (
  featureType: GeckoFeatureModelType,
  formFields: FormField[]
): GeckoFeaturesJSON => {
  switch (featureType) {
    case GeckoFeatureModelType.Course:
      return ShellCourseJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ConeCourse:
      return ConeCourseJSONFromFormFields(formFields)
    case GeckoFeatureModelType.Plate:
      return PlateJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PolygonalPlate:
      return PolygonalPlateJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ConePlate:
      return ConicalPlateJSONFromFormFields(formFields)
    case GeckoFeatureModelType.VerticalWeld:
      return VerticalWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.HorizontalWeld:
      return HorizontalWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ConeCircumferentialWeld:
      return ConeCircumferentialWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ConeRadialWeld:
      return ConeRadialWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PipeSeamWeld:
      return PipeSeamWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PipeCircumferentialWeld:
      return PipeCircumferentialWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckBitt:
      return ShipDeckBittJSONFromForm(formFields)
    case GeckoFeatureModelType.ShipDeckChock:
      return ShipDeckChockJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckHatch:
      return ShipDeckHatchJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PipeNonIntegralSupport:
      return PipeNonIntegralSupportJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PipeIntegralSupport:
      return PipeIntegralSupportJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PipeWrap:
      return PipeWrapJSONFromFormFields(formFields)
    case GeckoFeatureModelType.Nozzle:
      return NozzleJSONFromFormFields(formFields)
    case GeckoFeatureModelType.Manway:
      return ManwayJSONFromFormFields(formFields)
    case GeckoFeatureModelType.FixedSensor:
      return FixedSensorJSONFromFormFields(formFields)
    case GeckoFeatureModelType.LegacyBoilerRepairRegion:
      return LegacyBoilerRepairRegionJSONFromFormFields(formFields)
    case GeckoFeatureModelType.LegacyBoilerWall:
      return LegacyBoilerWallJSONFromFormFields(formFields)
    case GeckoFeatureModelType.CoatingRegion:
      return CoatingJSONFromFormFields(formFields)
    case GeckoFeatureModelType.SphericalPlate:
      return SphericalPlateJSONFromFormFields(formFields)
    case GeckoFeatureModelType.LeakDetectionValve:
      return LeakDetectionValveJSONFromFormFields(formFields)
    case GeckoFeatureModelType.LinerRegion:
      return LinerJSONFromFormFields(formFields)
  }
}

export const getNewJSONForFeatureType = (
  featureType: GeckoFeatureModelType
): GeckoFeaturesJSON => {
  switch (featureType) {
    case GeckoFeatureModelType.VerticalWeld:
      return NewGeckoVerticalWeldJSON
    case GeckoFeatureModelType.HorizontalWeld:
      return NewGeckoHorizontalWeldJSON
    case GeckoFeatureModelType.Plate:
      return NewGeckoPlateJSON
    case GeckoFeatureModelType.Nozzle:
      return NewGeckoNozzleJSON
    case GeckoFeatureModelType.Manway:
      return NewGeckoManwayJSON
    case GeckoFeatureModelType.FixedSensor:
      return NewGeckoFixedSensorJSON
    case GeckoFeatureModelType.PolygonalPlate:
      return NewGeckoPolygonalPlateJSON
    case GeckoFeatureModelType.LegacyBoilerRepairRegion:
      return NewGeckoLegacyBoilerRepairRegionJSON
    case GeckoFeatureModelType.LegacyBoilerWall:
      return NewGeckoLegacyBoilerWallJSON
    case GeckoFeatureModelType.ConeCourse:
      return NewGeckoConeCourseJSON
    case GeckoFeatureModelType.Course:
      return NewGeckoCourseJSON
    case GeckoFeatureModelType.ConeCircumferentialWeld:
      return NewGeckoConeCircumferentialWeldJSON
    case GeckoFeatureModelType.ConeRadialWeld:
      return NewGeckoConeRadialWeldJSON
    case GeckoFeatureModelType.ShipDeckBitt:
      return NewGeckoShipDeckBittJSON
    case GeckoFeatureModelType.ShipDeckChock:
      return NewGeckoShipDeckChockJSON
    case GeckoFeatureModelType.ShipDeckHatch:
      return NewGeckoShipDeckHatchJSON
    case GeckoFeatureModelType.PipeSeamWeld:
      return NewGeckoPipeSeamWeldJSON
    case GeckoFeatureModelType.PipeCircumferentialWeld:
      return NewGeckoPipeCircumferentialWeldJSON
    case GeckoFeatureModelType.PipeNonIntegralSupport:
      return NewGeckoPipeNonIntegralSupportJSON
    case GeckoFeatureModelType.PipeIntegralSupport:
      return NewGeckoPipeIntegralSupportJSON
    case GeckoFeatureModelType.PipeWrap:
      return NewGeckoPipeWrapJSON
    case GeckoFeatureModelType.ConePlate:
      return NewGeckoConicalPlateJSON
    case GeckoFeatureModelType.CoatingRegion:
      return NewGeckoCoatingJSON
    case GeckoFeatureModelType.SphericalPlate:
      return NewGeckoSphericalPlateJSON
    case GeckoFeatureModelType.LeakDetectionValve:
      return NewGeckoLeakDetectionValveJSON
    case GeckoFeatureModelType.LinerRegion:
      return NewGeckoLinerJSON
  }
}

export function getFeatureTableOptionsByType(
  type: GeckoFeatureModelType
): FeatureTableOptions {
  switch (type) {
    case GeckoFeatureModelType.Course:
      return ShellCourseFeatureTableOptions
    case GeckoFeatureModelType.Plate:
      return PlateFeatureTableOptions
    case GeckoFeatureModelType.Nozzle:
      return NozzleFeatureTableOptions
    case GeckoFeatureModelType.Manway:
      return ManwayFeatureTableOptions
    case GeckoFeatureModelType.FixedSensor:
      return FixedSensorFeatureTableOptions
    case GeckoFeatureModelType.VerticalWeld:
      return VerticalWeldFeatureTableOptions
    case GeckoFeatureModelType.HorizontalWeld:
      return HorizontalWeldFeatureTableOptions
    case GeckoFeatureModelType.PipeSeamWeld:
      return PipeSeamWeldFeatureTableOptions
    case GeckoFeatureModelType.PipeCircumferentialWeld:
      return PipeCircumferentialWeldFeatureTableOptions
    case GeckoFeatureModelType.PipeIntegralSupport:
      return PipeIntegralSupportFeatureTableOptions
    case GeckoFeatureModelType.PipeNonIntegralSupport:
      return PipeNonIntegralSupportFeatureTableOptions
    case GeckoFeatureModelType.PipeWrap:
      return PipeWrapFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckBitt:
      return ShipDeckBittFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckChock:
      return ShipDeckChockFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckHatch:
      return ShipDeckHatchFeatureTableOptions
    case GeckoFeatureModelType.LegacyBoilerWall:
      return LegacyBoilerWallFeatureTableOptions
    case GeckoFeatureModelType.ConeCourse:
      return ConeCourseFeatureTableOptions
    case GeckoFeatureModelType.ConePlate:
      return ConePlateFeatureTableOptions
    case GeckoFeatureModelType.ConeCircumferentialWeld:
      return ConeCircumferentialWeldFeatureTableOptions
    case GeckoFeatureModelType.ConeRadialWeld:
      return ConeRadialWeldFeatureTableOptions
    case GeckoFeatureModelType.LegacyBoilerRepairRegion:
      return LegacyBoilerRepairRegionFeatureTableOptions
    case GeckoFeatureModelType.PolygonalPlate:
      return PolygonalPlateFeatureTableOptions
    case GeckoFeatureModelType.CoatingRegion:
      return CoatingRegionFeatureTableOptions
    case GeckoFeatureModelType.SphericalPlate:
      return SphericalPlateFeatureTableOptions
    case GeckoFeatureModelType.LeakDetectionValve:
      return LeakDetectionValveFeatureTableOptions
    case GeckoFeatureModelType.LinerRegion:
      return LinerRegionFeatureTableOptions
    default:
      throw new Error(`Unsupported feature type: ${type}`)
  }
}

export function getSortedFeatureList(
  featureJSON: Record<string, GeckoFeaturesJSON>,
  sortBy: SortTableByField[] | undefined
): [string, GeckoFeaturesJSON][] {
  const sortedFeatureList = Object.entries(featureJSON)
  if (sortBy && sortBy.length > 0) {
    // Sort the array of entries based on the criteria specified in sortBy
    sortedFeatureList.sort((featureTupleA, featureTupleB) => {
      const featureA = featureTupleA[1]
      const featureB = featureTupleB[1]
      for (let i = 0; i < sortBy.length; i++) {
        const { fieldName, order } = sortBy[i]
        const aFields = getFormFieldsForFeatureType(featureA)
        const bFields = getFormFieldsForFeatureType(featureB)
        const aValue = getFormFieldByDataKey(aFields, fieldName)
          ?.value as number
        const bValue = getFormFieldByDataKey(bFields, fieldName)
          ?.value as number

        if (aValue < bValue) {
          return order === 'asc' ? -1 : 1
        } else if (aValue > bValue) {
          return order === 'asc' ? 1 : -1
        }
      }
      // If no differences are found for the given sort fields, return 0, meaning equal
      return 0
    })
  }

  return sortedFeatureList
}
